/**
 * Digital Advisor Solutions Service API 1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Observable } from 'rxjs';
import { AjaxRequest } from 'rxjs/observable/dom/AjaxObservable';
//@ts-ignore
// import * as models from '../model/models';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { ObjectUtils } from '@assetmark/ui-kit/dist/utils/object.utils';


import { ContainerName } from '../model/containerName';
import { ImageSize } from '../model/imageSize';
import { WBGetStartedImages } from '../model/wBGetStartedImages';

import {
	DasApiClient as ApiClient
	
} from '../../../apis/api.client';

// import isNotNullable = ObjectUtils.isNotNullable;

type TQueryParam = {
	key: string,
	value: string | string[] | boolean | number | Date | undefined,
}


// eslint-disable-next-line @typescript-eslint/no-namespace 
export namespace ResourcesService {
	/**
	* 
		* @summary Download image
	* @param path - URI : \&quot;CMSImagesStore00/logos/AG0166-logo.jpeg\&quot;
	*/
	export function apiDasV1ResourcesDownloadlogoGet(logoPath?: string, customHeaders: Object = {}): Observable<RemoteData<{}>> {
		const path = `/api/das/v1/Resources/downloadlogo`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
				{
					key: 'path',
					value: logoPath
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1ResourcesDownloadlogoGet(logoPath?: string, ): string {
		const path = '/api/das/v1/Resources/downloadlogo'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
			{
			key: 'path',
			value: logoPath
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Download Blob data
	* @param url - URI : https://azncd01edhadl1.blob.core.windows.net/getstartedimages/1_Wealth_Builder_LANDING.png
	*/
	export function apiDasV1ResourcesGet(url?: string, customHeaders: Object = {}): Observable<RemoteData<{}>> {
		const path = `/api/das/v1/Resources`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
				{
					key: 'url',
					value: url
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1ResourcesGet(url?: string, ): string {
		const path = '/api/das/v1/Resources'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
			{
			key: 'url',
			value: url
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Get the List of Url of Images from Blob container
	* @param containerName - 
	* @param imageSizeType - 
	* @param index - 
	*/
	export function apiDasV1ResourcesImagesGet(containerName?: ContainerName, imageSizeType?: ImageSize, index?: number, customHeaders: Object = {}): Observable<RemoteData<Array<WBGetStartedImages>>> {
		const path = `/api/das/v1/Resources/images`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
				{
					key: 'containerName',
					value: containerName
				},
				{
					key: 'imageSizeType',
					value: imageSizeType
				},
				{
					key: 'index',
					value: index
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1ResourcesImagesGet(containerName?: ContainerName, imageSizeType?: ImageSize, index?: number, ): string {
		const path = '/api/das/v1/Resources/images'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
			{
			key: 'containerName',
			value: containerName
			},
			{
			key: 'imageSizeType',
			value: imageSizeType
			},
			{
			key: 'index',
			value: index
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
	/**
	* 
		* @summary Get the List of Url of Images from Blob container
	*/
	export function apiDasV1ResourcesIntroductionGetstartedGet(customHeaders: Object = {}): Observable<RemoteData<Array<WBGetStartedImages>>> {
		const path = `/api/das/v1/Resources/introduction/getstarted`.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'get',
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1ResourcesIntroductionGetstartedGet(): string {
		const path = '/api/das/v1/Resources/introduction/getstarted'.replace(/^\//, '');
		const allQueryParams: TQueryParam[] = [
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
}
